// import addDays from 'date-fns/addDays';
// import endOfDay from 'date-fns/endOfDay';
// import startOfDay from 'date-fns/startOfDay';
import { useSelector } from 'react-redux';

import type { TOrdersByType } from '../../interfaces/orders';
import type { GlobalState } from '../index';

export function useOrders(): TOrdersByType {
  return useSelector((state: GlobalState) => state.orders.orders);
}

export function useIsOrdersLoaded(): boolean {
  return useSelector((state: GlobalState) => state.orders.isLoaded);
}
